var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { catchError, map } from "rxjs";
import { ApiResponseData } from "../../../models/api-response-data";
import { HealthResponse } from "../../../models/system/health-response";
import { Endpoint } from "../../endpoint";
/**
 * An endpoint to get Knora's state of health.
 *
 * @category Endpoint System
 */
var HealthEndpointSystem = /** @class */ (function (_super) {
    __extends(HealthEndpointSystem, _super);
    function HealthEndpointSystem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns Knora's state of health.
     */
    HealthEndpointSystem.prototype.getHealthStatus = function () {
        var _this = this;
        return this.httpGet("").pipe(map(function (ajaxResponse) {
            return ApiResponseData.fromAjaxResponse(ajaxResponse, HealthResponse, _this.jsonConvert);
        }), catchError(function (error) { return _this.handleError(error); }));
    };
    return HealthEndpointSystem;
}(Endpoint));
export { HealthEndpointSystem };
